"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getGovFlatRatePrice = exports.getEligibleGovFlatRateClassesAndType = void 0;
exports.getFlatRateClassWithType = getFlatRateClassWithType;
exports.parseFlatRateClassWithType = parseFlatRateClassWithType;
exports.getGovFlatRateDistanceTier = getGovFlatRateDistanceTier;
exports.getGovFlatRateClass = getGovFlatRateClass;
exports.getFieldFromFlatRate = getFieldFromFlatRate;
var moment_1 = __importDefault(require("@ambler/moment"));
var _1 = require(".");
var getEligibleGovFlatRateClassesAndType = function (departureTime) {
    var useLatestSsrGovFlatRate = (0, moment_1.default)(departureTime).isSameOrAfter((0, moment_1.default)('2024-01-01T00:00:00'));
    return [
        'ST1_PSY',
        'ST2_PSY',
        'ST3_PSY',
        useLatestSsrGovFlatRate ? 'ST4_SSR' : 'ST1_SSR',
        useLatestSsrGovFlatRate ? 'ST5_SSR' : 'ST2_SSR',
        useLatestSsrGovFlatRate ? 'ST6_SSR' : 'ST3_SSR',
        'TDE_MCO',
        'TSE_MCO',
    ];
};
exports.getEligibleGovFlatRateClassesAndType = getEligibleGovFlatRateClassesAndType;
function getFlatRateClassWithType(govFlatRate) {
    if (!govFlatRate) {
        return null;
    }
    switch (govFlatRate) {
        case 'ST1_SSR':
        case 'ST1_SSR_0_25':
        case 'ST1_SSR_25_75':
        case 'ST1_SSR_75_150':
        case 'ST1_SSR_150_300':
        case 'ST1_SSR_300':
            return 'ST1_SSR';
        case 'ST1_PSY':
        case 'ST1_PSY_0_25':
        case 'ST1_PSY_25_75':
        case 'ST1_PSY_75_150':
        case 'ST1_PSY_150_300':
        case 'ST1_PSY_300':
            return 'ST1_PSY';
        case 'ST2_SSR':
        case 'ST2_SSR_0_20':
        case 'ST2_SSR_20_50':
        case 'ST2_SSR_50_120':
        case 'ST2_SSR_120':
            return 'ST2_SSR';
        case 'ST2_PSY':
        case 'ST2_PSY_0_20':
        case 'ST2_PSY_20_50':
        case 'ST2_PSY_50_120':
        case 'ST2_PSY_120':
            return 'ST2_PSY';
        case 'ST3_SSR':
        case 'ST3_SSR_0_20':
        case 'ST3_SSR_20_50':
        case 'ST3_SSR_50_120':
        case 'ST3_SSR_120':
            return 'ST3_SSR';
        case 'ST3_PSY':
        case 'ST3_PSY_0_20':
        case 'ST3_PSY_20_50':
        case 'ST3_PSY_50_120':
        case 'ST3_PSY_120':
            return 'ST3_PSY';
        case 'TDE_MCO':
        case 'TDE_MCO_0_25':
        case 'TDE_MCO_25_75':
        case 'TDE_MCO_75_150':
        case 'TDE_MCO_150_300':
        case 'TDE_MCO_300':
            return 'TDE_MCO';
        case 'TSE_MCO':
        case 'TSE_MCO_0_40':
        case 'TSE_MCO_40_80':
        case 'TSE_MCO_80_160':
        case 'TSE_MCO_160':
            return 'TSE_MCO';
        case 'ST4_0_25':
        case 'ST4_25_75':
        case 'ST4_75_150':
        case 'ST4_150_300':
        case 'ST4_300':
            return 'ST4_SSR';
        case 'ST5_0_20':
        case 'ST5_20_50':
        case 'ST5_50_120':
        case 'ST5_120':
            return 'ST5_SSR';
        case 'ST6_0_20':
        case 'ST6_20_50':
        case 'ST6_50_120':
        case 'ST6_120':
            return 'ST6_SSR';
    }
    (0, _1.assertUnreachable)(govFlatRate);
}
function parseFlatRateClassWithType(govFlatRateClassAndType) {
    if (!govFlatRateClassAndType) {
        return null;
    }
    switch (govFlatRateClassAndType) {
        case 'ST1_PSY':
            return ['ST1', 'PSY'];
        case 'ST2_PSY':
            return ['ST2', 'PSY'];
        case 'ST3_PSY':
            return ['ST3', 'PSY'];
        // ? Deprecated in favor of ST4 on 01/01/2024:
        case 'ST1_SSR':
            return ['ST1', 'SSR'];
        case 'ST4_SSR':
            return ['ST4', 'SSR'];
        // ? Deprecated in favor of ST5 on 01/01/2024:
        case 'ST2_SSR':
            return ['ST2', 'SSR'];
        case 'ST5_SSR':
            return ['ST5', 'SSR'];
        // ? Deprecated in favor of ST6 on 01/01/2024:
        case 'ST3_SSR':
            return ['ST3', 'SSR'];
        case 'ST6_SSR':
            return ['ST6', 'SSR'];
        case 'TDE_MCO':
            return ['TDE', 'MCO'];
        case 'TSE_MCO':
            return ['TSE', 'MCO'];
    }
    (0, _1.assertUnreachable)(govFlatRateClassAndType);
}
/**
 * Compute corresponding Government Flat Rate
 */
function getGovFlatRateDistanceTier(govFlatRateClass, mfdType, distanceInMeters) {
    if (!govFlatRateClass || isNaN(distanceInMeters)) {
        return null;
    }
    var distance = distanceInMeters / 1000;
    if (govFlatRateClass === 'ST1') {
        switch (true) {
            case distance < 25:
                return mfdType === 'SSR' ? 'ST1_SSR_0_25' : 'ST1_PSY_0_25';
            case distance < 75:
                return mfdType === 'SSR' ? 'ST1_SSR_25_75' : 'ST1_PSY_25_75';
            case distance < 150:
                return mfdType === 'SSR' ? 'ST1_SSR_75_150' : 'ST1_PSY_75_150';
            case distance < 300:
                return mfdType === 'SSR' ? 'ST1_SSR_150_300' : 'ST1_PSY_150_300';
            case distance >= 300:
                return mfdType === 'SSR' ? 'ST1_SSR_300' : 'ST1_PSY_300';
        }
    }
    else if (govFlatRateClass === 'TDE') {
        switch (true) {
            case distance < 25:
                return 'TDE_MCO_0_25';
            case distance < 75:
                return 'TDE_MCO_25_75';
            case distance < 150:
                return 'TDE_MCO_75_150';
            case distance < 300:
                return 'TDE_MCO_150_300';
            case distance >= 300:
                return 'TDE_MCO_300';
        }
    }
    else if (govFlatRateClass === 'ST4') {
        switch (true) {
            case distance < 25:
                return 'ST4_0_25';
            case distance < 75:
                return 'ST4_25_75';
            case distance < 150:
                return 'ST4_75_150';
            case distance < 300:
                return 'ST4_150_300';
            case distance >= 300:
                return 'ST4_300';
        }
    }
    else if (govFlatRateClass === 'TSE') {
        switch (true) {
            case distance < 40:
                return 'TSE_MCO_0_40';
            case distance < 80:
                return 'TSE_MCO_40_80';
            case distance < 160:
                return 'TSE_MCO_80_160';
            case distance >= 160:
                return 'TSE_MCO_160';
        }
    }
    else if (govFlatRateClass === 'ST2') {
        switch (true) {
            case distance < 20:
                return mfdType === 'SSR' ? 'ST2_SSR_0_20' : 'ST2_PSY_0_20';
            case distance < 50:
                return mfdType === 'SSR' ? 'ST2_SSR_20_50' : 'ST2_PSY_20_50';
            case distance < 120:
                return mfdType === 'SSR' ? 'ST2_SSR_50_120' : 'ST2_PSY_50_120';
            case distance >= 120:
                return mfdType === 'SSR' ? 'ST2_SSR_120' : 'ST2_PSY_120';
        }
    }
    else if (govFlatRateClass === 'ST5') {
        switch (true) {
            case distance < 20:
                return 'ST5_0_20';
            case distance < 50:
                return 'ST5_20_50';
            case distance < 120:
                return 'ST5_50_120';
            case distance >= 120:
                return 'ST5_120';
        }
    }
    else if (govFlatRateClass === 'ST3') {
        switch (true) {
            case distance < 20:
                return mfdType === 'SSR' ? 'ST3_SSR_0_20' : 'ST3_PSY_0_20';
            case distance < 50:
                return mfdType === 'SSR' ? 'ST3_SSR_20_50' : 'ST3_PSY_20_50';
            case distance < 120:
                return mfdType === 'SSR' ? 'ST3_SSR_50_120' : 'ST3_PSY_50_120';
            case distance >= 120:
                return mfdType === 'SSR' ? 'ST3_SSR_120' : 'ST3_PSY_120';
        }
    }
    else if (govFlatRateClass === 'ST6') {
        switch (true) {
            case distance < 20:
                return 'ST6_0_20';
            case distance < 50:
                return 'ST6_20_50';
            case distance < 120:
                return 'ST6_50_120';
            case distance >= 120:
                return 'ST6_120';
        }
    }
    return null;
}
var getGovFlatRatePrice2021 = function (govFlatRate) {
    switch (govFlatRate) {
        //? Before 2020-03-01
        case 'ST1_PSY':
            return 10000;
        case 'ST2_PSY':
        case 'ST3_PSY':
            return 11000;
        case 'ST1_SSR':
            return 10600;
        case 'ST2_SSR':
        case 'ST3_SSR':
            return 19100;
        case 'TDE_MCO':
            return 12169;
        case 'TSE_MCO':
            return 14420;
        //? Since 2020-03-01
        // ST1_SSR
        case 'ST1_SSR_0_25':
            return 7854;
        case 'ST1_SSR_25_75':
            return 12768;
        case 'ST1_SSR_75_150':
            return 23721;
        case 'ST1_SSR_150_300':
            return 41270;
        case 'ST1_SSR_300':
            return 91847;
        // ST1_PSY
        case 'ST1_PSY_0_25':
            return 6415;
        case 'ST1_PSY_25_75':
            return 9830;
        case 'ST1_PSY_75_150':
            return 17943;
        case 'ST1_PSY_150_300':
            return 34355;
        case 'ST1_PSY_300':
            return 94910;
        // TDE
        case 'TDE_MCO_0_25':
            return 8204;
        case 'TDE_MCO_25_75':
            return 14554;
        case 'TDE_MCO_75_150':
            return 27421;
        case 'TDE_MCO_150_300':
            return 45120;
        case 'TDE_MCO_300':
            return 99127;
        // TSE
        case 'TSE_MCO_0_40':
            return 16961;
        case 'TSE_MCO_40_80':
            return 22941;
        case 'TSE_MCO_80_160':
            return 34678;
        case 'TSE_MCO_160':
            return 51584;
        // ST2_PSY / ST3_PSY
        case 'ST2_PSY_0_20':
        case 'ST3_PSY_0_20':
            return 10103;
        case 'ST2_PSY_20_50':
        case 'ST3_PSY_20_50':
            return 11030;
        case 'ST2_PSY_50_120':
        case 'ST3_PSY_50_120':
            return 12024;
        case 'ST2_PSY_120':
        case 'ST3_PSY_120':
            return 15170;
        // ST2_SSR / ST3_SSR
        case 'ST2_SSR_0_20':
        case 'ST3_SSR_0_20':
            return 15801;
        case 'ST2_SSR_20_50':
        case 'ST3_SSR_20_50':
            return 17219;
        case 'ST2_SSR_50_120':
        case 'ST3_SSR_50_120':
            return 20375;
        case 'ST2_SSR_120':
        case 'ST3_SSR_120':
            return 30324;
        // ? Not in use before 01/01/2024:
        case 'ST4_0_25':
        case 'ST4_25_75':
        case 'ST4_75_150':
        case 'ST4_150_300':
        case 'ST4_300':
        case 'ST5_0_20':
        case 'ST5_20_50':
        case 'ST5_50_120':
        case 'ST5_120':
        case 'ST6_0_20':
        case 'ST6_20_50':
        case 'ST6_50_120':
        case 'ST6_120':
            return 0;
    }
    (0, _1.assertUnreachable)(govFlatRate);
};
var getGovFlatRatePrice2022 = function (govFlatRate) {
    switch (govFlatRate) {
        //? Before 2020-03-01
        case 'ST1_PSY':
        case 'ST2_PSY':
        case 'ST3_PSY':
        case 'ST1_SSR':
        case 'ST2_SSR':
        case 'ST3_SSR':
        case 'TDE_MCO':
        case 'TSE_MCO':
            return 0; // deprecated
        //? Since 2022-03-01
        // ST1_SSR
        case 'ST1_SSR_0_25':
            return 7854;
        case 'ST1_SSR_25_75':
            return 12768;
        case 'ST1_SSR_75_150':
            return 23721;
        case 'ST1_SSR_150_300':
            return 41270;
        case 'ST1_SSR_300':
            return 91847;
        // ST1_PSY
        case 'ST1_PSY_0_25':
            return 6415;
        case 'ST1_PSY_25_75':
            return 9830;
        case 'ST1_PSY_75_150':
            return 17943;
        case 'ST1_PSY_150_300':
            return 34355;
        case 'ST1_PSY_300':
            return 94910;
        // TDE
        case 'TDE_MCO_0_25':
            return 8238;
        case 'TDE_MCO_25_75':
            return 14615;
        case 'TDE_MCO_75_150':
            return 27536;
        case 'TDE_MCO_150_300':
            return 45310;
        case 'TDE_MCO_300':
            return 99543;
        // TSE
        case 'TSE_MCO_0_40':
            return 17032;
        case 'TSE_MCO_40_80':
            return 23037;
        case 'TSE_MCO_80_160':
            return 34824;
        case 'TSE_MCO_160':
            return 51801;
        // ST2_PSY / ST3_PSY
        case 'ST2_PSY_0_20':
        case 'ST3_PSY_0_20':
            return 10103;
        case 'ST2_PSY_20_50':
        case 'ST3_PSY_20_50':
            return 11030;
        case 'ST2_PSY_50_120':
        case 'ST3_PSY_50_120':
            return 12024;
        case 'ST2_PSY_120':
        case 'ST3_PSY_120':
            return 15170;
        // ST2_SSR / ST3_SSR
        case 'ST2_SSR_0_20':
        case 'ST3_SSR_0_20':
            return 15801;
        case 'ST2_SSR_20_50':
        case 'ST3_SSR_20_50':
            return 17219;
        case 'ST2_SSR_50_120':
        case 'ST3_SSR_50_120':
            return 20375;
        case 'ST2_SSR_120':
        case 'ST3_SSR_120':
            return 30324;
        // ? Not in use before 01/01/2024
        case 'ST4_0_25':
        case 'ST4_25_75':
        case 'ST4_75_150':
        case 'ST4_150_300':
        case 'ST4_300':
        case 'ST5_0_20':
        case 'ST5_20_50':
        case 'ST5_50_120':
        case 'ST5_120':
        case 'ST6_0_20':
        case 'ST6_20_50':
        case 'ST6_50_120':
        case 'ST6_120':
            return 0;
    }
    (0, _1.assertUnreachable)(govFlatRate);
};
var getGovFlatRatePrice2023 = function (govFlatRate) {
    switch (govFlatRate) {
        //? Before 2020-03-01
        case 'ST1_PSY':
        case 'ST2_PSY':
        case 'ST3_PSY':
        case 'ST1_SSR':
        case 'ST2_SSR':
        case 'ST3_SSR':
        case 'TDE_MCO':
        case 'TSE_MCO':
            return 0; // deprecated
        //? Since 2023-03-01
        // ST1_SSR
        case 'ST1_SSR_0_25':
            return 8003;
        case 'ST1_SSR_25_75':
            return 13011;
        case 'ST1_SSR_75_150':
            return 24172;
        case 'ST1_SSR_150_300':
            return 42054;
        case 'ST1_SSR_300':
            return 93592;
        // ST1_PSY
        case 'ST1_PSY_0_25':
            return 6537;
        case 'ST1_PSY_25_75':
            return 10017;
        case 'ST1_PSY_75_150':
            return 18284;
        case 'ST1_PSY_150_300':
            return 35008;
        case 'ST1_PSY_300':
            return 96713;
        // TDE
        case 'TDE_MCO_0_25':
            return 8680;
        case 'TDE_MCO_25_75':
            return 15400;
        case 'TDE_MCO_75_150':
            return 29014;
        case 'TDE_MCO_150_300':
            return 47743;
        case 'TDE_MCO_300':
            return 104888;
        // TSE
        case 'TSE_MCO_0_40':
            return 17946;
        case 'TSE_MCO_40_80':
            return 24274;
        case 'TSE_MCO_80_160':
            return 36694;
        case 'TSE_MCO_160':
            return 54582;
        // ST2_PSY / ST3_PSY
        case 'ST2_PSY_0_20':
        case 'ST3_PSY_0_20':
            return 10295;
        case 'ST2_PSY_20_50':
        case 'ST3_PSY_20_50':
            return 11240;
        case 'ST2_PSY_50_120':
        case 'ST3_PSY_50_120':
            return 12252;
        case 'ST2_PSY_120':
        case 'ST3_PSY_120':
            return 15458;
        // ST2_SSR / ST3_SSR
        case 'ST2_SSR_0_20':
        case 'ST3_SSR_0_20':
            return 16101;
        case 'ST2_SSR_20_50':
        case 'ST3_SSR_20_50':
            return 17546;
        case 'ST2_SSR_50_120':
        case 'ST3_SSR_50_120':
            return 20762;
        case 'ST2_SSR_120':
        case 'ST3_SSR_120':
            return 30900;
        // ? Not in use before 01/01/2024
        case 'ST4_0_25':
        case 'ST4_25_75':
        case 'ST4_75_150':
        case 'ST4_150_300':
        case 'ST4_300':
        case 'ST5_0_20':
        case 'ST5_20_50':
        case 'ST5_50_120':
        case 'ST5_120':
        case 'ST6_0_20':
        case 'ST6_20_50':
        case 'ST6_50_120':
        case 'ST6_120':
            return 0;
    }
    (0, _1.assertUnreachable)(govFlatRate);
};
var getGovFlatRatePrice2024 = function (govFlatRate) {
    switch (govFlatRate) {
        case 'ST1_PSY':
        case 'ST2_PSY':
        case 'ST3_PSY':
        case 'TDE_MCO':
        case 'TSE_MCO':
        case 'ST1_SSR':
        case 'ST1_SSR_0_25':
        case 'ST1_SSR_25_75':
        case 'ST1_SSR_75_150':
        case 'ST1_SSR_150_300':
        case 'ST1_SSR_300':
        case 'ST2_SSR':
        case 'ST2_SSR_0_20':
        case 'ST2_SSR_20_50':
        case 'ST2_SSR_50_120':
        case 'ST2_SSR_120':
        case 'ST3_SSR':
        case 'ST3_SSR_0_20':
        case 'ST3_SSR_20_50':
        case 'ST3_SSR_50_120':
        case 'ST3_SSR_120':
            return 0; // deprecated
        // ST1_PSY
        case 'ST1_PSY_0_25':
            return 6537;
        case 'ST1_PSY_25_75':
            return 10017;
        case 'ST1_PSY_75_150':
            return 18284;
        case 'ST1_PSY_150_300':
            return 35008;
        case 'ST1_PSY_300':
            return 96713;
        // TDE
        case 'TDE_MCO_0_25':
            return 8680;
        case 'TDE_MCO_25_75':
            return 15400;
        case 'TDE_MCO_75_150':
            return 29014;
        case 'TDE_MCO_150_300':
            return 47743;
        case 'TDE_MCO_300':
            return 104888;
        // TSE
        case 'TSE_MCO_0_40':
            return 17946;
        case 'TSE_MCO_40_80':
            return 24274;
        case 'TSE_MCO_80_160':
            return 36694;
        case 'TSE_MCO_160':
            return 54582;
        // ST2_PSY / ST3_PSY
        case 'ST2_PSY_0_20':
        case 'ST3_PSY_0_20':
            return 10295;
        case 'ST2_PSY_20_50':
        case 'ST3_PSY_20_50':
            return 11240;
        case 'ST2_PSY_50_120':
        case 'ST3_PSY_50_120':
            return 12252;
        case 'ST2_PSY_120':
        case 'ST3_PSY_120':
            return 15458;
        case 'ST4_0_25':
            return 8869;
        case 'ST4_25_75':
            return 14419;
        case 'ST4_75_150':
            return 26788;
        case 'ST4_150_300':
            return 46605;
        case 'ST4_300':
            return 103719;
        case 'ST5_0_20':
        case 'ST6_0_20':
            return 17843;
        case 'ST5_20_50':
        case 'ST6_20_50':
            return 19445;
        case 'ST5_50_120':
        case 'ST6_50_120':
            return 23009;
        case 'ST5_120':
        case 'ST6_120':
            return 34244;
    }
    (0, _1.assertUnreachable)(govFlatRate);
};
var getGovFlatRatePriceFromSecondBimester2024 = function (govFlatRate) {
    switch (govFlatRate) {
        case 'ST1_PSY':
        case 'ST2_PSY':
        case 'ST3_PSY':
        case 'TDE_MCO':
        case 'TSE_MCO':
        case 'ST1_SSR':
        case 'ST1_SSR_0_25':
        case 'ST1_SSR_25_75':
        case 'ST1_SSR_75_150':
        case 'ST1_SSR_150_300':
        case 'ST1_SSR_300':
        case 'ST2_SSR':
        case 'ST2_SSR_0_20':
        case 'ST2_SSR_20_50':
        case 'ST2_SSR_50_120':
        case 'ST2_SSR_120':
        case 'ST3_SSR':
        case 'ST3_SSR_0_20':
        case 'ST3_SSR_20_50':
        case 'ST3_SSR_50_120':
        case 'ST3_SSR_120':
            return 0; // deprecated
        // ST1_PSY
        case 'ST1_PSY_0_25':
            return 6537;
        case 'ST1_PSY_25_75':
            return 10017;
        case 'ST1_PSY_75_150':
            return 18284;
        case 'ST1_PSY_150_300':
            return 35008;
        case 'ST1_PSY_300':
            return 96713;
        // TDE
        case 'TDE_MCO_0_25':
            return 8680;
        case 'TDE_MCO_25_75':
            return 15400;
        case 'TDE_MCO_75_150':
            return 29014;
        case 'TDE_MCO_150_300':
            return 47743;
        case 'TDE_MCO_300':
            return 104888;
        // TSE
        case 'TSE_MCO_0_40':
            return 17946;
        case 'TSE_MCO_40_80':
            return 24274;
        case 'TSE_MCO_80_160':
            return 36694;
        case 'TSE_MCO_160':
            return 54582;
        // ST2_PSY / ST3_PSY
        case 'ST2_PSY_0_20':
        case 'ST3_PSY_0_20':
            return 10295;
        case 'ST2_PSY_20_50':
        case 'ST3_PSY_20_50':
            return 11240;
        case 'ST2_PSY_50_120':
        case 'ST3_PSY_50_120':
            return 12252;
        case 'ST2_PSY_120':
        case 'ST3_PSY_120':
            return 15458;
        case 'ST4_0_25':
            return 8959;
        case 'ST4_25_75':
            return 14566;
        case 'ST4_75_150':
            return 27061;
        case 'ST4_150_300':
            return 47080;
        case 'ST4_300':
            return 104777;
        case 'ST5_0_20':
        case 'ST6_0_20':
            return 18025;
        case 'ST5_20_50':
        case 'ST6_20_50':
            return 19643;
        case 'ST5_50_120':
        case 'ST6_50_120':
            return 23244;
        case 'ST5_120':
        case 'ST6_120':
            return 34593;
    }
    (0, _1.assertUnreachable)(govFlatRate);
};
var getGovFlatRatePrice2025 = function (govFlatRate) {
    switch (govFlatRate) {
        case 'ST1_PSY':
        case 'ST2_PSY':
        case 'ST3_PSY':
        case 'TDE_MCO':
        case 'TSE_MCO':
        case 'ST1_SSR':
        case 'ST1_SSR_0_25':
        case 'ST1_SSR_25_75':
        case 'ST1_SSR_75_150':
        case 'ST1_SSR_150_300':
        case 'ST1_SSR_300':
        case 'ST2_SSR':
        case 'ST2_SSR_0_20':
        case 'ST2_SSR_20_50':
        case 'ST2_SSR_50_120':
        case 'ST2_SSR_120':
        case 'ST3_SSR':
        case 'ST3_SSR_0_20':
        case 'ST3_SSR_20_50':
        case 'ST3_SSR_50_120':
        case 'ST3_SSR_120':
            return 0; // deprecated
        // ST1_PSY
        case 'ST1_PSY_0_25':
            return 6537;
        case 'ST1_PSY_25_75':
            return 10017;
        case 'ST1_PSY_75_150':
            return 18284;
        case 'ST1_PSY_150_300':
            return 35008;
        case 'ST1_PSY_300':
            return 96713;
        // TDE
        case 'TDE_MCO_0_25':
            return 8695;
        case 'TDE_MCO_25_75':
            return 15427;
        case 'TDE_MCO_75_150':
            return 29066;
        case 'TDE_MCO_150_300':
            return 47828;
        case 'TDE_MCO_300':
            return 105074;
        // TSE
        case 'TSE_MCO_0_40':
            return 17978;
        case 'TSE_MCO_40_80':
            return 24317;
        case 'TSE_MCO_80_160':
            return 36759;
        case 'TSE_MCO_160':
            return 54679;
        // ST2_PSY / ST3_PSY
        case 'ST2_PSY_0_20':
        case 'ST3_PSY_0_20':
            return 10295;
        case 'ST2_PSY_20_50':
        case 'ST3_PSY_20_50':
            return 11240;
        case 'ST2_PSY_50_120':
        case 'ST3_PSY_50_120':
            return 12252;
        case 'ST2_PSY_120':
        case 'ST3_PSY_120':
            return 15458;
        case 'ST4_0_25':
            return 9002;
        case 'ST4_25_75':
            return 14636;
        case 'ST4_75_150':
            return 27191;
        case 'ST4_150_300':
            return 47306;
        case 'ST4_300':
            return 105280;
        case 'ST5_0_20':
        case 'ST6_0_20':
            return 18112;
        case 'ST5_20_50':
        case 'ST6_20_50':
            return 19738;
        case 'ST5_50_120':
        case 'ST6_50_120':
            return 23355;
        case 'ST5_120':
        case 'ST6_120':
            return 34759;
    }
    (0, _1.assertUnreachable)(govFlatRate);
};
var getGovFlatRatePriceFebruary2026 = function (govFlatRate) {
    switch (govFlatRate) {
        case 'ST1_PSY':
        case 'ST2_PSY':
        case 'ST3_PSY':
        case 'TDE_MCO':
        case 'TSE_MCO':
        case 'ST1_SSR':
        case 'ST1_SSR_0_25':
        case 'ST1_SSR_25_75':
        case 'ST1_SSR_75_150':
        case 'ST1_SSR_150_300':
        case 'ST1_SSR_300':
        case 'ST2_SSR':
        case 'ST2_SSR_0_20':
        case 'ST2_SSR_20_50':
        case 'ST2_SSR_50_120':
        case 'ST2_SSR_120':
        case 'ST3_SSR':
        case 'ST3_SSR_0_20':
        case 'ST3_SSR_20_50':
        case 'ST3_SSR_50_120':
        case 'ST3_SSR_120':
            return 0; // deprecated
        // ST1_PSY
        case 'ST1_PSY_0_25':
            return 6829;
        case 'ST1_PSY_25_75':
            return 10464;
        case 'ST1_PSY_75_150':
            return 19099;
        case 'ST1_PSY_150_300':
            return 36569;
        case 'ST1_PSY_300':
            return 101026;
        // TDE
        case 'TDE_MCO_0_25':
            return 8695;
        case 'TDE_MCO_25_75':
            return 15427;
        case 'TDE_MCO_75_150':
            return 29066;
        case 'TDE_MCO_150_300':
            return 47828;
        case 'TDE_MCO_300':
            return 105074;
        // TSE
        case 'TSE_MCO_0_40':
            return 17978;
        case 'TSE_MCO_40_80':
            return 24317;
        case 'TSE_MCO_80_160':
            return 36759;
        case 'TSE_MCO_160':
            return 54679;
        // ST2_PSY / ST3_PSY
        case 'ST2_PSY_0_20':
        case 'ST3_PSY_0_20':
            return 10754;
        case 'ST2_PSY_20_50':
        case 'ST3_PSY_20_50':
            return 11741;
        case 'ST2_PSY_50_120':
        case 'ST3_PSY_50_120':
            return 12798;
        case 'ST2_PSY_120':
        case 'ST3_PSY_120':
            return 16147;
        case 'ST4_0_25':
            return 9002;
        case 'ST4_25_75':
            return 14636;
        case 'ST4_75_150':
            return 27191;
        case 'ST4_150_300':
            return 47306;
        case 'ST4_300':
            return 105280;
        case 'ST5_0_20':
        case 'ST6_0_20':
            return 18112;
        case 'ST5_20_50':
        case 'ST6_20_50':
            return 19738;
        case 'ST5_50_120':
        case 'ST6_50_120':
            return 23355;
        case 'ST5_120':
        case 'ST6_120':
            return 34759;
    }
    (0, _1.assertUnreachable)(govFlatRate);
};
var getGovFlatRatePrice = function (govFlatRate, departureTime) {
    if (!govFlatRate) {
        return null;
    }
    if ((0, moment_1.default)(departureTime).isSameOrAfter('2026-02-01')) {
        return getGovFlatRatePriceFebruary2026(govFlatRate);
    }
    if ((0, moment_1.default)(departureTime).isSameOrAfter('2025-03-01')) {
        return getGovFlatRatePrice2025(govFlatRate);
    }
    if ((0, moment_1.default)(departureTime).isSameOrAfter('2024-03-01')) {
        return getGovFlatRatePriceFromSecondBimester2024(govFlatRate);
    }
    if ((0, moment_1.default)(departureTime).isAfter('2024-01-01')) {
        return getGovFlatRatePrice2024(govFlatRate);
    }
    if ((0, moment_1.default)(departureTime).isAfter('2023-03-01')) {
        return getGovFlatRatePrice2023(govFlatRate);
    }
    if ((0, moment_1.default)(departureTime).isAfter('2022-03-01')) {
        return getGovFlatRatePrice2022(govFlatRate);
    }
    return getGovFlatRatePrice2021(govFlatRate);
};
exports.getGovFlatRatePrice = getGovFlatRatePrice;
function getGovFlatRateClass(govFlatRate) {
    if (!govFlatRate) {
        return null;
    }
    switch (govFlatRate) {
        case 'ST1_SSR':
        case 'ST1_PSY':
        case 'ST1_SSR_0_25':
        case 'ST1_SSR_25_75':
        case 'ST1_SSR_75_150':
        case 'ST1_SSR_150_300':
        case 'ST1_SSR_300':
        case 'ST1_PSY_0_25':
        case 'ST1_PSY_25_75':
        case 'ST1_PSY_75_150':
        case 'ST1_PSY_150_300':
        case 'ST1_PSY_300':
            return 'ST1';
        case 'ST2_SSR':
        case 'ST2_PSY':
        case 'ST2_PSY_0_20':
        case 'ST2_PSY_20_50':
        case 'ST2_PSY_50_120':
        case 'ST2_PSY_120':
        case 'ST2_SSR_0_20':
        case 'ST2_SSR_20_50':
        case 'ST2_SSR_50_120':
        case 'ST2_SSR_120':
            return 'ST2';
        case 'ST3_SSR':
        case 'ST3_PSY':
        case 'ST3_PSY_0_20':
        case 'ST3_PSY_20_50':
        case 'ST3_PSY_50_120':
        case 'ST3_PSY_120':
        case 'ST3_SSR_0_20':
        case 'ST3_SSR_20_50':
        case 'ST3_SSR_50_120':
        case 'ST3_SSR_120':
            return 'ST3';
        case 'ST4_0_25':
        case 'ST4_25_75':
        case 'ST4_75_150':
        case 'ST4_150_300':
        case 'ST4_300':
            return 'ST4';
        case 'ST5_0_20':
        case 'ST5_20_50':
        case 'ST5_50_120':
        case 'ST5_120':
            return 'ST5';
        case 'ST6_0_20':
        case 'ST6_20_50':
        case 'ST6_50_120':
        case 'ST6_120':
            return 'ST6';
        case 'TDE_MCO':
        case 'TDE_MCO_0_25':
        case 'TDE_MCO_25_75':
        case 'TDE_MCO_75_150':
        case 'TDE_MCO_150_300':
        case 'TDE_MCO_300':
            return 'TDE';
        case 'TSE_MCO':
        case 'TSE_MCO_0_40':
        case 'TSE_MCO_40_80':
        case 'TSE_MCO_80_160':
        case 'TSE_MCO_160':
            return 'TSE';
    }
    (0, _1.assertUnreachable)(govFlatRate);
}
function getFieldFromFlatRate(govFlatRate) {
    if (!govFlatRate) {
        return null;
    }
    switch (govFlatRate) {
        case 'ST1_PSY':
        case 'ST1_PSY_0_25':
        case 'ST1_PSY_25_75':
        case 'ST1_PSY_75_150':
        case 'ST1_PSY_150_300':
        case 'ST1_PSY_300':
        case 'ST2_PSY':
        case 'ST2_PSY_0_20':
        case 'ST2_PSY_20_50':
        case 'ST2_PSY_50_120':
        case 'ST2_PSY_120':
        case 'ST3_PSY':
        case 'ST3_PSY_0_20':
        case 'ST3_PSY_20_50':
        case 'ST3_PSY_50_120':
        case 'ST3_PSY_120':
            return 'PSY';
        case 'ST1_SSR':
        case 'ST1_SSR_0_25':
        case 'ST1_SSR_25_75':
        case 'ST1_SSR_75_150':
        case 'ST1_SSR_150_300':
        case 'ST1_SSR_300':
        case 'ST2_SSR':
        case 'ST2_SSR_0_20':
        case 'ST2_SSR_20_50':
        case 'ST2_SSR_50_120':
        case 'ST2_SSR_120':
        case 'ST3_SSR':
        case 'ST3_SSR_0_20':
        case 'ST3_SSR_20_50':
        case 'ST3_SSR_50_120':
        case 'ST3_SSR_120':
        case 'ST4_0_25':
        case 'ST4_25_75':
        case 'ST4_75_150':
        case 'ST4_150_300':
        case 'ST4_300':
        case 'ST5_0_20':
        case 'ST5_20_50':
        case 'ST5_50_120':
        case 'ST5_120':
        case 'ST6_0_20':
        case 'ST6_20_50':
        case 'ST6_50_120':
        case 'ST6_120':
            return 'SSR';
        case 'TDE_MCO':
        case 'TDE_MCO_0_25':
        case 'TDE_MCO_25_75':
        case 'TDE_MCO_75_150':
        case 'TDE_MCO_150_300':
        case 'TDE_MCO_300':
        case 'TSE_MCO':
        case 'TSE_MCO_0_40':
        case 'TSE_MCO_40_80':
        case 'TSE_MCO_80_160':
        case 'TSE_MCO_160':
            return 'MCO';
    }
    (0, _1.assertUnreachable)(govFlatRate);
}
//# sourceMappingURL=gov-flat-rate.js.map